import { Button, Caption, H2, H4, H5 } from '@/components';
import CommonBlok from '@/components/common-blok';
import React from 'react';
import * as styles from './index.module.less';
import { ReactComponent as LineLeftDeco } from '@/images/svg/line-left-deco.svg';
import { ReactComponent as LineRightDeco } from '@/images/svg/line-right-deco.svg';
import { IImportCase, ImportCaseList } from '../../constants';
import { LoadingImageUrl, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import RatioMedia from '@/components/ratio-media';

const CaseCard = (data: IImportCase) => {
  return (
    <div className={styles.case_card}>
      <a href={data.link} className={styles.case_cover}>
        <RatioMedia
          media={{
            type: 'image',
            src: data.withPic.src,
            alt: data.withPic.alt,
          }}
          mediaStyle={{
            borderRadius: '12px',
          }}
          isLazyLoad
        />
      </a>
      <div className={styles.company_info_container}>
        <div className={styles.company_logo}>
          <img className="lozad" src={LoadingImageUrl} data-src={data.companyLogo.src} alt={data.companyLogo.alt} />
        </div>
        <H5>{data.companyName}</H5>
        <div className={styles.company_tags_container}>
          {data.companyTag.map((item, index) => {
            return (
              <div key={index} className={styles.company_tag}>
                <Caption className={styles.company_tag_text}>{item}</Caption>
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.title_desc_container}>
        <H4>{data.title}</H4>
        <p>{data.desc}</p>
      </div>
    </div>
  );
};

const ImportCase = () => {
  return (
    <CommonBlok
      title={
        <div className={styles.title_container}>
          <div className={styles.sub_title_container}>
            <LineLeftDeco stroke="#85C6FF" />
            <H4 className={styles.title_header}>工数を90%削減 ! 情報利用の効率が10倍に !</H4>
            <LineRightDeco stroke="#85C6FF" />
          </div>
          <H2>導入事例</H2>
        </div>
      }
      blokBg="#F8F9FA"
      isNewLayout
      className={styles.import_case_blok}
    >
      <div className={styles.blok_content}>
        <div className={styles.case_card_container}>
          {ImportCaseList.map((item, index) => {
            return <CaseCard key={index} {...item} />;
          })}
        </div>
        <div className={styles.btn_group}>
          <a href={WEB_APP_JP_SIGN_UP_URL} data-gtm="home-page-import-case-sign-up-btn">
            <Button>無料ではじめる</Button>
          </a>
          <a href="/about" data-gtm="home-page-import-case-to-about-page-btn">
            <Button type="primary">法人向けのお問い合わせ</Button>
          </a>
        </div>
      </div>
    </CommonBlok>
  );
};
export default ImportCase;
